define('utils/image-comparison-slider', [
    'jquery',
    'underscore',
    'velocity',
    'velocity.ui'
],  function ($, _, Velocity, VelocityUi) {
    'use strict';

    console.log('%cfile: image-comparison-slider.js', 'color: #C2ECFF');

    var el = '[data-image-comparison-slider]',
        original = '[data-image-comparison-slider-original]',
        other = '[data-image-comparison-slider-other]',
        otherWrap = '[data-image-comparison-slider-other-wrap]',
        otherImage = '[data-image-comparison-slider-other-image]',

        $el,

        initialize,
        followMouse,
        moveTouch;

    var imageComparisonSlider = function imageComparisonSlider(){
        console.log('%ctrace: imageComparisonSlider', 'color: #ccc');

        $el = $(el);

        if($el.length <= 0){
            console.warn('%ctrace: imageComparisonSlider: not found dom elements', 'color: #ccc');
            return false;
        }

        $el.each(function(i, el){
            initialize($(el));
        });
    };

    followMouse = function followMouse($el) {
        var $other = $el.find(other),
            width = $el.width(),
            left = $el.offset().left,
            mousemove = false,

            onHandleMousemove,
            onHandleMouseout;

        function onHandleMousemove(event) {
            mousemove = true;
            width = $el.width();
            left = $el.offset().left;

            var diff = (event.pageX - left)*100/width;
            diff = (diff >= 100) ? 100 : diff;
            diff = (diff <= 0) ? 0 : diff;

            $other.css('width', diff + '%');
        }

        function onHandleMouseout() {
            mousemove = false;

            setTimeout(function(){
                if(mousemove){
                    return false;
                }
            }, 500);

            setTimeout(function(){
                if(mousemove){
                    return false;
                }

                $other.velocity('stop').velocity({
                    'width' : '50%'
                }, {
                    duration: 200
                });
            }, 10000);
        }

        $el.off('mousemove').on('mousemove', onHandleMousemove);
        $el.off('mouseout').on('mouseout', onHandleMouseout);
    };

    moveTouch = function moveTouch($el) {
        var $other = $el.find(other),
            width = $el.width(),
            left = $el.offset().left,
            mousemove = false,

            state = {
                startPosX: 0,
                startPosY: 0,
                topMove: 0,
                leftMove: 0
            };

        function saveState (event) {
            state.startPosX = event.pageX || event.originalEvent.touches[0].pageX;
            state.startPosY = event.pageY || event.originalEvent.touches[0].pageY;

            state.event = event;
        }

        function move (event) {
            var cursor = {};

            cursor.x = event.pageX || event.originalEvent.touches[0].pageX;
            cursor.y = event.pageY || event.originalEvent.touches[0].pageY;

            state.leftMove = cursor.x;
            state.topMove = cursor.y;

            var diff = (state.leftMove - left)*100/width;
            diff = (diff >= 100) ? 100 : diff;
            diff = (diff <= 0) ? 0 : diff;

            $other.css('width', diff + '%');
        }

        function onHandleTouchstart (event) {
            event.preventDefault();

            saveState(event);
        }

        function onHandleTouchend () {
            mousemove = false;
        }

        function onHandleTouchmove(event){
            event.preventDefault();

            mousemove = true;
            move(event);
            saveState(event);
        }

        function onHandleDrag(event){
            event.preventDefault();
        }

        $el.on('touchstart', onHandleTouchstart);
        $el.on('touchend', onHandleTouchend);
        $el.on('touchmove', onHandleTouchmove);
        $el.on('drag', onHandleDrag);
    };

    initialize = function initialize($el){
        var $otherImage = $el.find(otherImage);
        $otherImage.css('width', $el.width());
        $otherImage.css('opacity', 1);

        followMouse($el);
        moveTouch($el);
    };

    return imageComparisonSlider;
});
